import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { classNames } from "Utils/utils";
import closeIcon from "assets/close-icon.png";

const WorkerShiftModal = ({
  isOpen,
  onClose,
  closeModal,
  children,
  modalFooter = null,
  title = "",
  titleCss = null,
  cssClass,
  bodyPadding = "p-4",
  headerAction = null,
  fullScreen = false,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modalContent = (
    <div
      className={classNames(
        fullScreen
          ? "fixed inset-0 z-[99999] flex flex-col bg-white"
          : "fixed inset-0 z-[10000] flex items-center justify-center bg-gray-800 bg-opacity-75 p-4"
      )}
      role="dialog"
      aria-modal="true"
    >
      <div
        ref={modalRef}
        className={classNames(
          cssClass,
          fullScreen
            ? "flex h-full w-full min-h-0 flex-col overflow-hidden bg-white"
            : "relative z-60 flex w-full max-h-[90vh] flex-col rounded-lg borderRadiusX bg-white shadow-xl transition-all"
        )}
      >
        <div
          className={classNames(
            "relative flex-shrink-0 border-b border-gray-400 p-4",
            fullScreen ? "" : "rounded-t-xl",
            title === "" && "h-[57px]",
            titleCss ? titleCss : "bg-gradient"
          )}
        >
          {title && (
            <h3
              className={classNames(
                "pr-4 text-lg font-semibold leading-6 tracking-wider text-white",
                titleCss !== null && "text-center text-black"
              )}
            >
              {title}
            </h3>
          )}
          <div className="absolute right-4 top-4 flex items-center gap-3">
            {headerAction && <div className="text-white">{headerAction}</div>}
            {closeModal && (
              <div className="cursor-pointer text-white" onClick={closeModal}>
                <img
                  src={closeIcon}
                  alt="close icon"
                  className="h-5 w-5 max-w-[20px]"
                />
              </div>
            )}
          </div>
        </div>

        <div
          className={classNames(
            bodyPadding,
            "custom-scroll min-h-0 flex-1 overflow-y-auto"
          )}
        >
          {children}
        </div>

        {modalFooter && (
          <div className="flex flex-shrink-0 justify-end gap-x-2 border-t border-gray-200 bg-gray-50 p-3">
            {modalFooter}
          </div>
        )}
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(modalContent, document.body);
};

export default WorkerShiftModal;
